// extracted by mini-css-extract-plugin
export var cardTitle = "_jr-1";
export var commentBubble = "_jr-e";
export var commentForm = "_jr-a";
export var commentInput = "_jr-b";
export var commentLabel = "_jr-d";
export var commentPrompt = "_jr-9";
export var csatCard = "_jr-0";
export var feedbackSection = "_jr-7";
export var starDisabled = "_jr-6";
export var starEmpty = "_jr-5";
export var starFilled = "_jr-4";
export var starWrapper = "_jr-3";
export var starsContainer = "_jr-2";
export var submittedComment = "_jr-c";
export var thankYouText = "_jr-8";